// import fonts from './fonts'


const textStyles = {}

export default textStyles
